import { createAsyncThunk } from "@reduxjs/toolkit";
import * as API from "./api";

// get department
export const getDepartment = createAsyncThunk("department/getDepartment", async (params, { rejectWithValue }) => {
  const { rowsPerPage, search, sortOrder, pageNo } = params;

  try {
    const { data } = await API.getDepartment({ rowsPerPage: rowsPerPage, search, sortOrder, pageNo });
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get all department
export const getAllDepartment = createAsyncThunk("department/getAllDepartment", async (_, { rejectWithValue }) => {
  try {
    const { data } = await API.getAllDepartment();
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get previous
export const getPrevious = createAsyncThunk("department/getPrevious", async (previous, { rejectWithValue }) => {
  try {
    const { data } = await API.getPrevious(previous);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
// get next
export const getNext = createAsyncThunk("department/getNext", async (next, { rejectWithValue }) => {
  try {
    const { data } = await API.getNext(next);

    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// get particular page
export const getParticularPage = createAsyncThunk(
  "department/getParticularPage",
  async (params, { rejectWithValue }) => {
    const { number, rowsPerPage, search } = params;

    try {
      const { data } = await API.getPageDepartment({ number, rowsPerPage: rowsPerPage, search });
      return data;
    } catch (error) {
      return rejectWithValue(error?.response?.data?.message);
    }
  }
);
// get particular page
export const getDepartmentById = createAsyncThunk("department/getDepartmentById", async (id, { rejectWithValue }) => {
  try {
    const { data } = await API.getDepartmentById(id);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});

// create department
export const createDepartment = createAsyncThunk("department/createDepartment", async (data, { rejectWithValue }) => {
  const { name, code, allowSales, allowPurchase } = data;
  try {
    const body = JSON.stringify({ name, code, allowSales, allowPurchase });
    const { data } = await API.createDepartment(body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});
export const updateDepartment = createAsyncThunk("department/updateDepartment", async (data, { rejectWithValue }) => {
  const { id, values } = data;
  const { name, code, allowSales, allowPurchase } = values;
  try {
    const body = JSON.stringify({ name, code, allowSales, allowPurchase });
    const { data } = await API.updateDepartment(id, body);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data);
  }
});

// handle search
export const handleSearch = createAsyncThunk("department/handleSearch", async (data, { rejectWithValue }) => {
  const { search, rowsPerPage } = data;
  try {
    const { data } = await API.handleSearch(search, rowsPerPage);
    return data;
  } catch (error) {
    return rejectWithValue(error?.response?.data?.message);
  }
});
